/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'

import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesFileRender from '../styles/FileRender.module.css'

// Components

function DefaultFileRender(props) {
  return (
    <div
      className={stylesFileRender['default-file-render']}
    >
      <div
        className={stylesFileRender['file-name']}
      >
        {props.file?.name}
      </div>
      {`{`}
      <div
        className={stylesFileRender['file-value-row']}
      >
        <span
          className={stylesFileRender['value-key']}
        >
          type:
        </span>
        <span>
          {props.file?.type || 'N/A'}
        </span>
      </div>
      <div
        className={stylesFileRender['file-value-row']}
      >
        <span
          className={stylesFileRender['value-key']}
        >
          size:
        </span>
        <span>
          {Helpers.fileSizeFormat(props.file?.size) || 'N/A'}
        </span>
      </div>
      <div
        className={stylesFileRender['file-value-row']}
      >
        <span
          className={stylesFileRender['value-key']}
        >
          last modified date:
        </span>
        <span>
          {props.file?.lastModifiedDate?.toString() || 'N/A'}
        </span>
      </div>
      {`}`}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(DefaultFileRender)
